<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import 'styles/reset.stylus'
export default {
  
}
</script>
<style lang="stylus">
@import '~styles/icons.css'
</style>
